import { createContext, useState, useMemo } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const GlobalContext = createContext({});

function GlobalProvider({children}) {
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [authModalType, setAuthModalType] = useState("login");
    const [units, setUnits] = useState('imperial');
    const [loginMessage, setLoginMessage] = useState('');
    const [ssoUserData, setSsoUserData] = useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const value = useMemo(() => ({
        isMobile,
        showAuthModal, setShowAuthModal,
        authModalType, setAuthModalType,
        units, setUnits,
        loginMessage, setLoginMessage,
        ssoUserData, setSsoUserData
    }), [isMobile, showAuthModal, authModalType, units, loginMessage, ssoUserData]);

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
}
    
export { GlobalProvider, GlobalContext};